(() => {
  if (window.geosortContact) { window.geosortContact.init(); return; }
  let audience = new URLSearchParams(location.search).get('audience') === 'agency' ? 'agency' : 'merchant';
  function sync() {
    document.querySelectorAll('[data-contact-toggle]').forEach(toggle => { toggle.hidden = false; });
    document.querySelectorAll('[data-contact-select]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.contactSelect === audience)));
    document.querySelectorAll('[data-contact-audience]').forEach(panel => {
      const active = panel.dataset.contactAudience === audience || panel.dataset.contactAudience === 'both';
      panel.hidden = !active;
      if (panel.tagName === 'FIELDSET') {
        panel.disabled = !active;
        panel.querySelectorAll('[data-contact-required]').forEach(field => { field.required = active; });
      }
    });
    document.querySelectorAll('[data-gcontact-form]').forEach(root => {
      root.querySelector('[data-contact-audience-input]').value = audience === 'agency' ? 'Agency' : 'Merchant';
      root.querySelector('[data-contact-subject]').value = `Geosort ${audience} enquiry`;
      const returnTo = root.querySelector('[name="return_to"]');
      if (returnTo) {
        const url = new URL(returnTo.value, location.origin);
        url.searchParams.set('audience', audience);
        returnTo.value = url.pathname + url.search + url.hash;
      }
    });
  }
  function init() {
    sync();
    document.querySelectorAll('[data-gcontact-form]:not([data-contact-ready])').forEach(root => {
      root.dataset.contactReady = 'true';
      const success = root.querySelector('[data-contact-success]');
      const errors = root.querySelector('[data-contact-errors]');
      if (!errors && new URLSearchParams(location.search).get('contact_posted') === 'true') success.hidden = false;
      if (!success.hidden) {
        root.querySelector('[data-contact-fields]').hidden = true;
        const announce = () => requestAnimationFrame(() => {
          if (document.activeElement === document.body || root.contains(document.activeElement)) {
            success.scrollIntoView({ block: 'center' });
            success.focus({ preventScroll: true });
          }
        });
        if (document.readyState === 'complete') announce();
        else window.addEventListener('load', announce, { once: true });
      }
      if (errors) { errors.focus({ preventScroll: true }); errors.scrollIntoView({ block: 'center' }); }
    });
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-contact-select]');
    if (!button) return;
    audience = button.dataset.contactSelect;
    const url = new URL(location.href);
    if (audience === 'merchant') url.searchParams.delete('audience');
    else url.searchParams.set('audience', audience);
    history.replaceState(history.state, '', url);
    sync();
  });
  window.addEventListener('popstate', () => {
    audience = new URLSearchParams(location.search).get('audience') === 'agency' ? 'agency' : 'merchant';
    sync();
  });
  document.addEventListener('shopify:section:load', init);
  window.geosortContact = { init };
  init();
})();
